import {IStatusIconProps} from 'components/ui/Icon/StatusIcons/IStatusIconProps';

const WaitingIcon = (props: IStatusIconProps) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx="10" cy="10" r="10" fill="#FFBF1D" />
            <path
                d="M13.5 5H6.5C6.20833 5 6 5.21484 6 5.46875V5.78125C6 6.05469 6.20833 6.25 6.5 6.25C6.5 8.02734 7.5625 9.53125 9 10C7.5625 10.4883 6.5 11.9922 6.5 13.75C6.20833 13.75 6 13.9648 6 14.2188V14.5312C6 14.8047 6.20833 15 6.5 15H13.5C13.7708 15 14 14.8047 14 14.5312V14.2188C14 13.9648 13.7708 13.75 13.5 13.75C13.5 11.9922 12.4167 10.4883 10.9792 10C12.4167 9.53125 13.5 8.02734 13.5 6.25C13.7708 6.25 14 6.05469 14 5.78125V5.46875C14 5.21484 13.7708 5 13.5 5ZM11.9167 12.5H8.0625C8.41667 11.6016 9.14583 10.9375 10 10.9375C10.8333 10.9375 11.5625 11.6016 11.9167 12.5ZM11.9167 7.5H8.0625C7.89583 7.12891 7.83333 6.69922 7.83333 6.25H12.1667C12.1667 6.69922 12.0833 7.12891 11.9167 7.5Z"
                fill="white"
            />
        </svg>
    );
};

export default WaitingIcon;
